import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getGbpPosts(campaignId) {
  return axios.get(`/ajax/gbp_campaigns/${campaignId}/gbp_posts`)
}

export function getLocationGbpPosts(locationId, params = {}) {
  return axios.get(`/ajax/locations/${locationId}/gbp_posts`, { params })
}

export function getGbpPost(id) {
  return axios.get(`/ajax/gbp_posts/${id}`)
}

export function updateGbpPost(id, data) {
  return axios.patch(`/ajax/gbp_posts/${id}`, data)
}

export function regenerateGbpPost(id) {
  return axios.post(`/ajax/gbp_posts/${id}/regenerate`)
}

export function qualityCheckGbpPost(id) {
  return axios.post(`/ajax/gbp_posts/${id}/quality_check`)
}

export function uploadGbpPostImage(id, file) {
  const formData = new FormData()
  formData.append('image', file)
  return axios.post(`/ajax/gbp_posts/${id}/upload_image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function sendForApproval(postId, data = {}) {
  return axios.post(`/ajax/gbp_posts/${postId}/send_for_approval`, { approval: data })
}

export function getApproval(postId) {
  return axios.get(`/ajax/gbp_posts/${postId}/approval`)
}

export function resubmitApproval(postId) {
  return axios.patch(`/ajax/gbp_posts/${postId}/resubmit_approval`)
}

export function createApprovalComment(postId, body) {
  return axios.post(`/ajax/gbp_posts/${postId}/create_approval_comment`, {
    comment: { body }
  })
}
